module.exports = __webpack_public_path__ + "static/opi-66f23dd41e34b3fd2fa74bbe37f9ad77.png";